import { getProperty } from "./get-property";

/**
 * Calls a function by name, which can be a shallow or deep object path starting from window.
 * @param functionName The full path of the function.
 * @param arg An optional argument to pass to the function.
 */
export function callFunction(functionName: string, arg?: any) {

	// check for a deep path
	const lastDot = functionName.lastIndexOf(".");
	if (lastDot > -1) {

		// it's a path, get the direct parent first
		const path = functionName.substring(0, lastDot);
		const name = functionName.substring(lastDot + 1);
		const container = getProperty(window, path);

		if (container) {

			// get the function and attempt to call it
			return container[name](arg);
		}
	}
	else {

		// get the function and attempt to call it
		return getProperty(window, functionName)(arg);
	}
}